<section class="page-user-profile">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="user-profile-images">
          <!-- user timeline image -->
          <img [src]="user.capaPlataforma ? user.capaPlataforma : '../../../../assets/img/banner/capa2.jpg'" class="img-fluid rounded-top user-timeline-image" style="width: 100%" alt="User Timeline Image">
          <!-- user profile image -->
          <img style="cursor: pointer;" [src]="user && user.photo_url ? user.photo_url : '../../../../assets/img/portrait/small/no-avatar.svg'" (click)="changePhoto()" class="user-profile-image rounded" alt="User Profile Image" height="140" width="140">
        </div>
        <div class="user-profile-text">
          <h4 class="profile-text-color mb-0" style="font-weight: 600">{{user ? user.name : ''}}</h4>
          <small>{{user ? user.email : ''}}</small>
        </div>
        <!-- user profile body start -->
        <div class="card-content">
          <div class="card-body">
            <div class="user-profile-buttons d-flex justify-content-center justify-content-sm-start">
              <ul ngbNav [(activeId)]="activeId" #nav="ngbNav" class="nav-tabs">
                <li ngbNavItem  [ngbNavItem]="1">
                  <a ngbNavLink><button type="button" class="btn btn-block btn-warning mb-2 mb-md-0">Informações</button></a>
                  <ng-template ngbNavContent>
                    <div class="row">
                      <div class="col-12">
                        <div class="card">
                          <div class="card-content">
                            <div class="card-body">
                              <h5>Dados Pessoais</h5>
                              <form #firstForm="ngForm" novalidate *ngIf="user">

                                <div class="form-row">
                                  <div class="col-md-4 col-12">
                                    <div class="form-group">
                                      <div class="controls">
                                        <label for="nome">Nome</label>
                                        <input type="text" id="nome" class="form-control" [(ngModel)]="user.name" name="nome" placeholder="Nome Completo"
                                                required aria-invalid="false">
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-3 col-12">
                                    <div class="form-group">
                                      <div class="controls">
                                        <label for="phone">Telefone  <i class="fa fa-question-circle" placement="top" ngbTooltip="Inclua o código do país. Ex: Brasil 55"></i></label>
                                        <input type="text" id="phone" class="form-control" [(ngModel)]="user.phone" name="phone" placeholder="5511987654321"
                                        required aria-invalid="false">
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-5 col-12">
                                    <div class="form-group">
                                      <div class="controls">
                                        <label for="sexo">Sexo</label>
                                        <select id="sexo" name="sexo" [(ngModel)]="user.gender" class="form-control">
                                          <option value="1">Masculino</option>
                                          <option value="2">Feminino</option>
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="form-row" style="padding-left: 1.5rem">
                                  <div class="col" >
                                    <button type="button" class="btn btn-lg btn-warning mb-2 mb-md-0 float-right" [disabled]="!firstForm.valid" (click)="updateUser()"  >Atualizar Usuário</button>
                                  </div>
                                </div>
                              </form>
                              <h5>Senha</h5>
                              <form #secondForm="ngForm" novalidate>
                                <div class="form-row">
                                  <div class="col-md-4 col-12">
                                    <div class="form-group">
                                      <div class="controls">
                                        <label for="senhaAtual">Senha Atual</label>
                                        <input type="password" [(ngModel)]="formUpdateSenha.password" id="senhaAtual" name="senhaAtual" class="form-control" placeholder="Senha Atual"
                                                required aria-invalid="false">
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-4 col-12">
                                    <div class="form-group">
                                      <div class="controls">
                                        <label for="novaSenha">Nova Senha</label>
                                        <input type="password" id="novaSenha" class="form-control" name="novaSenha" placeholder="Nova Senha"
                                               [(ngModel)]="formUpdateSenha.newPassword" required aria-invalid="false">
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-4 col-12">
                                    <div class="form-group">
                                      <div class="controls">
                                        <label for="confirmNovaSenha">Confirmar Nova Senha</label>
                                        <input type="password" id="confirmNovaSenha" name="confirmNovaSenha" class="form-control" placeholder="Confirmar Nova Senha"
                                               [(ngModel)]="formUpdateSenha.confirmPassword" required aria-invalid="false">
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="form-row" style="padding-left: 1.5rem">
                                  <div class="col" >
                                    <button type="button" class="btn btn-lg btn-warning mb-2 mb-md-0 float-right" [disabled]="!secondForm.valid"  (click)="updatePassword()"  >Atualizar Senha</button>
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <div class="card">
                          <div class="card-content">
                            <div class="card-body">
                              <button class="btn btn-warning border-right-warning mb-2 pulsingButton" (click)="OpenModalXl(contentTutoriais)"><i class="fa fa-play-circle-o"></i> Ver Vídeo Tutorial</button>
                              <h4>Personalização</h4>
                              <form #customForm="ngForm" novalidate *ngIf="user">

                                <div class="form-row">
                                  <div class="col-md-4 col-12">
                                    <div class="form-group">
                                      <div class="controls">
                                        <label for="whatsapp">Link do seu Whatsapp</label>
                                        <input type="text" id="whatsapp" class="form-control" [(ngModel)]="user.whatsapp" name="whatsapp" placeholder="https://wa.me/..."
                                                required aria-invalid="false">
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-4 col-12">
                                    <div class="form-group">
                                      <div class="controls">
                                        <label for="telegram">Link do seu Telegram</label>
                                        <input type="text" id="telegram" class="form-control" [(ngModel)]="user.telegram" name="telegram" placeholder="https://t.me/joinchat/..."
                                               required aria-invalid="false">
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-4 col-12">
                                    <div class="form-group">
                                      <div class="controls">
                                        <label for="instagram">Link do seu Instagram</label>
                                        <input type="text" id="instagram" class="form-control" [(ngModel)]="user.instagram" name="instagram" placeholder="https://www.instagram.com/..."
                                               required aria-invalid="false">
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="form-row">
                                  <div class="col-md-6 col-12">
                                    <div class="form-group">
                                      <div class="controls">
                                        <label for="site">Link do seu Site</label>
                                        <input type="text" id="site" class="form-control" [(ngModel)]="user.site" name="site" placeholder="https://www.meusite.com"
                                               required aria-invalid="false">
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-6 col-12">
                                    <div class="form-group">
                                      <div class="controls">
                                        <label for="suporte">Email para Suporte</label>
                                        <input type="text" id="suporte" class="form-control" [(ngModel)]="user.suporte" name="suporte" placeholder="meuemail@meusuporte.com"
                                               required aria-invalid="false">
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-12">
                                    <div class="form-group">
                                      <div class="controls">
                                        <label for="notes">Bio</label>
                                        <textarea id="notes" rows="2" class="form-control" name="notes"  #notesDescription maxlength="140"  [(ngModel)]="user.notes" #inputObse="ngModel" placeholder="Você pode informar uma breve descrição para sua Bio."></textarea>
                                        {{ 140 - notesDescription.value.length }} caracteres restantes.

                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="form-row" style="padding-left: 1.5rem">
                                  <div class="col" >
                                    <button type="button" class="btn btn-lg btn-warning mb-2 mt-2 mb-md-0 float-right" (click)="updateUser()"  >Atualizar Personalização</button>
                                  </div>
                                </div>
                                <hr>
                                <div class="row">
                                  <div class="col-12 col-lg-6">
                                    <h4 style="text-align: left">Cor Principal</h4>
                                    <p>Selecionar cor para tema principal</p>
                                    <div class="clearfix"></div>
                                    <div [style.backgroundColor]="selectedColor" class="color-preview"></div>
                                    <div class="color-picker-container">
                                      <input [style.background]="selectedColor" [cpOutputFormat]="'hex'" [cpFallbackColor]="'#2ebfca'" [cpIgnoredElements]="['ignoredButton', 'ignoredInput']" [(cpToggle)]="toggle" [(colorPicker)]="selectedColor" />
                                    </div>
                                    <p class="mt-0 mt-md-2">A cor selecionada será aplicada em ícones e botões principais.</p>
                                    <button type="button" class="btn btn-lg btn-warning mb-2 mt-2 mb-md-0" (click)="saveColor()">Salvar</button>
                                    <button *ngIf="selectedColor!='#2ebfca'" type="button" class="btn btn-lg btn-secondary mb-2 mt-2 mb-md-0 ml-2" (click)="resetAppColor()">Redefinir Cor</button>
                                    <p class="mt-2">Para a personalização funcionar os Apps devem estar nas seguintes versões:</p>
                                    <p>App do Aluno: 2.5.1</p>
                                    <p>App do personal: 1.2.1</p>
                                  </div>
                                  
                                  <div class="col-12 col-lg-6 mt-4 mt-md-0">
                                    <h4 style="text-align: center">Demonstração</h4>
                                    <div class="d-flex flex-sm-row flex-column justify-content-center px-0 mb-sm-2">
                                    <img src="../../../../assets/img/demo_personalizacao.png"  alt="user edit avatar" style="
                                          width: 420px;">
                                    </div>
                                  </div>
                                </div>
                                <hr>
                                <div class="row mt-3">
                                  <div class="col-12 col-lg-6">
                                    <h4>Logo de Abertura App</h4>
                                    <div class="col-12">
                                      <div class="d-flex flex-sm-row flex-column justify-content-center px-0 mb-sm-2">
                                        <p class="text-danger">É obrigatório a imagem ter uma proporção de 414px x 150px para manter uma qualidade boa para seu aluno. <a class="text-danger text-bold-500" href="https://www.iloveimg.com/pt/redimensionar-imagem" target="_blank" >Clique aqui para redimensionar sua imagem em uma ferramenta online e gratuita.</a></p>
                                      </div>
                                    </div>
                                   <div class="d-flex flex-sm-row flex-column justify-content-center px-0 mb-sm-2">
                                      <img [src]="user.banner ? user.banner : '../../assets/img/defaultbg.png'"  alt="user edit avatar" >
                                    </div>
                                    <div class="d-flex flex-sm-row flex-column justify-content-center px-0 mb-sm-2">
                                      <button class="btn btn-sm btn-warning mb-1 mb-sm-0" (click)="changeBanner()">Atualizar Logo</button>
                                      <button class="btn btn-sm bg-light-secondary ml-sm-2" *ngIf="user.banner">Visualizar Logo</button>
                                    </div>
                                  </div>
                                  <div class="col-12 col-lg-6 mt-4 mt-md-0">
                                    <h4 style="text-align: center">Demonstração</h4>
                                    <div class="d-flex flex-sm-row flex-column justify-content-center px-0 mb-sm-2">
                                    <img [src]="'https://files.wecodde.com/file/wecodde/logo_app_AdobeExpress.gif'"  alt="user edit avatar" style="
                                          width: 220px;">
                                    </div>
                                  </div>
                                </div>
                                <hr>
                                <div class="row">
                                  <div class="col-12 col-lg-6">
                                    <h4>Capa Interna da Plataforma</h4>
                                    <div class="col-12">
                                      <div class="d-flex flex-sm-row flex-column justify-content-center px-0 mb-sm-2">
                                        <p class="text-danger">É obrigatório a imagem ter uma proporção de 1980px x 480px para manter uma qualidade boa para seu aluno. <a class="text-danger text-bold-500" href="https://www.iloveimg.com/pt/redimensionar-imagem" target="_blank" >Clique aqui para redimensionar sua imagem em uma ferramenta online e gratuita.</a></p>
                                      </div>
                                    </div>
                                    <div class="col-12">
                                      <div class="d-flex flex-sm-row flex-column justify-content-center px-0 mb-sm-2">
                                        <p class="text-danger">Ainda não possui uma arte pronta?. <a class="text-danger text-bold-500" href="https://opersonaldigital.com.br/modelos-de-banner" target="_blank" >Clique aqui e utilize os nossos modelos exclusivos, personalize e insira sua logo e foto.</a></p>
                                      </div>
                                    </div>
                                    <div class="d-flex flex-sm-row flex-column justify-content-center px-0 mb-2 mt-sm-2">
                                      <img [src]="user.capaPlataforma ? user.capaPlataforma : '../../assets/img/banner/capa3.jpg'"  alt="user edit avatar" style="
                                          max-width: 400px;">
                                    </div>
                                    <div class="col-12">
                                      <div class="d-flex flex-sm-row flex-column justify-content-center px-0 mb-sm-2">
                                        <button class="btn btn-sm btn-warning mb-1 mb-sm-0" (click)="changeCapaPlataforma()">Atualizar Capa</button>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-12 col-lg-6 mt-4 mt-md-0">
                                    <h4 style="text-align: center">Demonstração</h4>
                                    <div class="d-flex flex-sm-row flex-column justify-content-center px-0 mb-sm-2">
                                      <img [src]="'https://files.wecodde.com/file/wecodde/capa_alterada.jpeg'"  alt="user edit avatar" style="
                                          width: -webkit-fill-available;max-width: 650px;">
                                    </div>
                                  </div>
                                  
                                </div>
                                <!-- <div class="row">
                                  <div class="col-12">
                                    <div class="d-flex flex-sm-row flex-column justify-content-center px-0 mb-sm-2">
                                      <button class="btn btn-sm btn-warning mb-1 mb-sm-0" (click)="changeCapaPlataforma()">Atualizar Capa</button>
                                      <button class="btn btn-sm bg-light-secondary ml-sm-2" *ngIf="user.capaPlataforma">Visualizar Capa</button>
                                    </div>
                                  </div>
                                </div> -->
                                <!-- <div class="row">
                                  <div class="col-12">
                                    <div class="d-flex flex-sm-row flex-column justify-content-center px-0 mb-sm-2">
                                      <p class="text-danger">É obrigatório a imagem ter uma proporção de 414px x 150px para manter uma qualidade boa para seu aluno. <a class="text-danger text-bold-500" href="https://www.iloveimg.com/pt/redimensionar-imagem" target="_blank" >Clique aqui para redimensionar sua imagem em uma ferramenta online e gratuita.</a></p>
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-12">
                                    <div class="d-flex flex-sm-row flex-column justify-content-center px-0 mb-sm-2">
                                      <p class="text-danger">Sugerimos você utilizar uma imagem sem fundo para uma melhor experiência de seu aluno. <a class="text-danger text-bold-500" href="https://www.remove.bg/pt-br/upload" target="_blank" >Clique aqui para remover o fundo de sua imagem em uma ferramenta online e gratuita.</a></p>
                                    </div>
                                  </div>
                                </div> -->
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12">
                        <div class="card">
                          <div class="card-content">
                            <div class="card-body">
                              <h5>Mensagens Promocionais</h5>
                              <form #firstForm="ngForm" novalidate *ngIf="user">

                                <div class="form-row justify-content-between">
                                  <div class="col-sm-auto">
                                    <div class="col align-self-start">                                    
                                        <div class="form-group">
                                          <div class="controls">
                                            <label for="nome">Habilitar mensagens promocionais para mim</label>  
                                          </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="col-sm-auto col-12">
                                    <div class="form-group">
                                      <div class="col aling-self-end">
                                        <div class="controls">
                                          <ui-switch checked class="switchery" placement="top" ngbTooltip="Ative ou desative as mensagens de promoção." (click)="updateAcceptPromoMessages(modal)" 
                                          name="acceptPromoMessages" [(ngModel)]="acceptPromoMessages" ngDefaultControl></ui-switch>    
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="w-100"></div>
                                  <br>

                                  <div class="form-row">
                                    <div class="col-sm-auto">
                                      <div class="col aling-self-start">
                                        <div class="form-group">
                                          <div class="controls">
                                            <label for="nome">Habilitar mensagens promocionais para meus alunos</label>
                                          </div>
                                        </div>  
                                      </div>
                                    </div>
                                  </div>

                                  <div class="col-sm-auto col-12">
                                    <div class="form-group">
                                      <div class="col aling-self-end">
                                        <div class="controls">
                                          <ui-switch checked class="switchery" placement="top" ngbTooltip="Ative ou desative as mensagens de promoção." (click)="updateAcceptPromoMessagesCustomers(modal)" 
                                          name="acceptPromoMessagesCustomers" [(ngModel)]="acceptPromoMessagesCustomers" ngDefaultControl></ui-switch>    
                                        </div>
                                      </div> 
                                    </div>
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>     
                  </ng-template>
                </li>
              </ul>
            </div>
          </div>
          <!-- user profile body ends -->
        </div>
      </div>
    </div>
  </div>
</section>

<div class="tab-content">
  <div [ngbNavOutlet]="nav"></div>
</div>
<ng-template #contentVideo>
  <ng-template [ngIf]="urlToPlay.startsWith('https://www.youtube.com/') || urlToPlay.startsWith('http://www.youtube.com/')">
    <div class='embed-container'><iframe  [src]="safeURL" frameborder='0' allowfullscreen></iframe></div>
  </ng-template>
  <ng-template [ngIf]="!urlToPlay.startsWith('https://www.youtube.com/') && !urlToPlay.startsWith('http://www.youtube.com/')">
    <video controls style="width: 100%;">
      <source [src]="safeURL" type="video/mp4">
    </video>
  </ng-template>
</ng-template>

<ng-template #contentTutoriais let-modal>
  <div class="card-header">
    <h4 class="card-title">Tutoriais</h4>
  </div>
  <button class="close-button" (click)="modal.close('Close click')"><i class="fa fa-times" aria-hidden="true"></i></button>
  <div class="form-row" style="margin: 5px">
    <ul class="list-group mb-2" style="width: 100%">
      <li class="list-group-item">
        <div class="media">
          <span class="dotModal align-middle mr-2">1</span>
          <div class="media-body">
            <h5 class="mt-0">Como personalizar o seu app</h5>
            <span></span>
          </div>
          <div class="d-none d-md-block">
            <button type="button" class="btn btn-outline-warning mb-2 mb-md-0" (click)="viewMidia( 'https://www.youtube.com/watch?v=z_PRCVqTNek', contentVideo )" >Vídeo</button>
          </div>
          <div class="d-md-none">
            <button type="button" class="btn btn-outline-warning mb-2 mb-md-0" (click)="viewMidia( 'https://www.youtube.com/watch?v=z_PRCVqTNek', contentVideo )" >Vídeo</button>
          </div>
        </div>
      </li>
      <li class="list-group-item">
        <div class="media">
          <span class="dotModal align-middle mr-2">2</span>
          <div class="media-body">
            <h5 class="mt-0">Como personalizar o banner interno da plataforma</h5>
            <span></span>
          </div>
          <div class="d-none d-md-block">
            <button type="button" class="btn btn-outline-warning mb-2 mb-md-0" (click)="viewMidia( 'https://www.youtube.com/watch?v=b50cOU8PHNE', contentVideo )" >Vídeo</button>
          </div>
          <div class="d-md-none">
            <button type="button" class="btn btn-outline-warning mb-2 mb-md-0" (click)="viewMidia( 'https://www.youtube.com/watch?v=b50cOU8PHNE', contentVideo )" >Vídeo</button>
          </div>
        </div>
      </li>
    </ul>
  </div>
</ng-template>
<ngx-spinner></ngx-spinner>
